<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="122"
    height="122"
    viewBox="0 0 122 122"
    fill="none"
  >
    <path
      d="M61.1915 121.762C94.3286 121.762 121.101 94.5314 120.99 60.9402C120.879 27.3491 93.9255 0.118088 60.7885 0.118088C27.6514 0.118088 0.878673 27.3491 0.989965 60.9402C1.10126 94.5314 28.0544 121.762 61.1915 121.762Z"
      fill="#26A17B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M68.2106 66.1987L68.2106 66.1911C67.7982 66.2216 65.6724 66.3508 60.9286 66.3508C57.1411 66.3508 54.4745 66.2368 53.5369 66.1911L53.5369 66.2026C38.9548 65.5525 28.0637 62.979 28.0535 59.8999C28.0433 56.8245 38.9173 54.251 53.4951 53.5896L53.5284 63.6404C54.4811 63.7088 57.2117 63.8723 60.9842 63.8723C65.5104 63.8723 67.7786 63.6822 68.2022 63.6442L68.1689 53.5972C82.7211 54.2548 93.5858 56.8283 93.596 59.8999C93.6062 62.979 82.7585 65.5449 68.2106 66.1987ZM68.1654 52.5518L68.1356 43.5577H88.4381L88.3927 29.8423H33.1139L33.1594 43.5577H53.4619L53.4917 52.548C36.9942 53.3159 24.5964 56.6307 24.6096 60.5993C24.6227 64.568 37.0425 67.879 53.545 68.6506L53.6405 97.4727H68.3143L68.2187 68.643C84.69 67.8752 97.0577 64.5642 97.0446 60.5993C97.0314 56.6345 84.6417 53.3235 68.1654 52.5518Z"
      fill="white"
    />
    <defs>
      <clipPath id="clip0_57252_1422">
        <rect
          width="120"
          height="121.645"
          fill="white"
          transform="matrix(1 0 0.00331313 0.999995 0.79834 0.117676)"
        />
      </clipPath>
    </defs>
  </svg>
</template>